function getNavLinks() {
    const NAV_LINKS = [
        {text: "Changelogs", link: "/software-changelogs"},
        {text: "Support", link: "#"},
        {text: "Pricing", link: "/subscription-plans"},
    ]

    return NAV_LINKS
}

export default getNavLinks;